import React, { useState } from "react"
import BillingForm from "../components/BillingForm"
import Header from "../components/Header"
import { useId } from "./useId"

function Billing(props) {
    let { id } = useId(props)

    const [title, setTitle] = useState("Subscription")

    return (
        <Header title={title}>
            <BillingForm accountId={id} setTitle={setTitle} />
        </Header>
    )
}

export default Billing
